import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { allTopics } from '@/utils/data';

export default function TopicSection() {
  return (
    <section id="topics" className="w-full bg-background-100 px-4 py-10 md:px-8 md:py-14">
      <SectionHeading title="特色专题" subtitle="深度策划，带你读懂一个话题" icon="ri-bookmark-line" />
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
        {allTopics.map((t, i) => (
          <Link
            key={t.id}
            to={`/category/${t.slug}`}
            className={`group relative overflow-hidden rounded-lg cursor-pointer ${i === 0 ? 'lg:col-span-1' : ''}`}
          >
            <div className="relative h-60 w-full overflow-hidden bg-background-200 md:h-64">
              <img
                src={t.cover}
                alt={t.title}
                title={`${t.title} - 色哟哟专题`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/30 to-transparent"></div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-0.5 text-xs font-medium text-background-50">
                <i className="ri-bookmark-fill"></i>
                专题
              </span>
              <h3 className="mt-3 text-lg font-bold text-background-50 transition-colors group-hover:text-primary-200">
                {t.title}
              </h3>
              <p className="mt-2 text-sm text-background-100/80 line-clamp-2">{t.desc}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-200">
                查看专题
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}